import { useMemo } from 'react';
import { RepositoryFactory } from '@/shared/infrastructure/RepositoryFactory';
import { WalletRepository } from '@/repositories/WalletRepository';
import { UserRepository } from '@/repositories/UserRepository';
import { AuthRepository } from '@/repositories/AuthRepository';
import { PersonalityRepository } from '@/repositories/personality/PersonalityRepository';
import { YoungSchemasRepository } from '@/repositories/personality/YoungSchemasRepository';
import { ReferralRepository } from '@/repositories/social/ReferralRepository';
import { ConversationRepository } from '@/repositories/social/ConversationRepository';

/**
 * Hook to access the repository factory
 */
export const useRepositoryFactory = () => {
  return useMemo(() => RepositoryFactory.getInstance(), []);
};

/**
 * Hook for wallet repository
 */
export const useWalletRepository = (): WalletRepository => {
  const factory = useRepositoryFactory();
  return factory.getWalletRepository();
};

/**
 * Hook for user repository
 */
export const useUserRepository = (): UserRepository => {
  const factory = useRepositoryFactory();
  return factory.getUserRepository();
};

/**
 * Hook for auth repository
 */
export const useAuthRepository = (): AuthRepository => {
  const factory = useRepositoryFactory();
  return factory.getAuthRepository();
};

/**
 * Hook for personality repository
 */
export const usePersonalityRepository = (): PersonalityRepository => {
  const factory = useRepositoryFactory();
  return factory.getPersonalityRepository();
};

/**
 * Hook for Young Schemas repository
 */
export const useYoungSchemasRepository = (): YoungSchemasRepository => {
  const factory = useRepositoryFactory();
  return factory.getYoungSchemasRepository();
};

/**
 * Hook for referral repository
 */
export const useReferralRepository = (): ReferralRepository => {
  const factory = useRepositoryFactory();
  return factory.getReferralRepository();
};

/**
 * Hook for conversation repository
 */
export const useConversationRepository = (): ConversationRepository => {
  const factory = useRepositoryFactory();
  return factory.getConversationRepository();
};
